var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoals(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 223,
    height: 222,
    viewBox: "0 0 223 222",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4673_12762)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4673_12762",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 223,
    height: 222
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0493164 1.52588e-05H222.049V222H0.0493164V1.52588e-05Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4673_12762)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.01 119.392C202.01 174.264 157.527 218.746 102.655 218.746C47.7841 218.746 3.30176 174.264 3.30176 119.392C3.30176 64.5203 47.7841 20.0379 102.655 20.0379C157.527 20.0379 202.01 64.5203 202.01 119.392Z",
    stroke: "#7f56d9",
    strokeWidth: 6.50391,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.656 191.438C142.38 191.438 174.699 159.119 174.699 119.394C174.699 79.6696 142.38 47.3508 102.656 47.3508C62.9311 47.3508 30.6123 79.6696 30.6123 119.394C30.6123 159.119 62.9311 191.438 102.656 191.438Z",
    stroke: "#7f56d9",
    strokeWidth: 6.50391,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.656 164.129C77.9905 164.129 57.9233 144.062 57.9233 119.396C57.9233 94.7305 77.9905 74.6633 102.656 74.6633C127.322 74.6633 147.389 94.7305 147.389 119.396C147.389 144.062 127.322 164.129 102.656 164.129Z",
    stroke: "#7f56d9",
    strokeWidth: 6.50391,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.656 136.816C93.0494 136.816 85.2334 129.001 85.2334 119.394C85.2334 109.787 93.0494 101.972 102.656 101.972C112.262 101.972 120.078 109.787 120.078 119.394C120.078 129.001 112.262 136.816 102.656 136.816Z",
    stroke: "#7f56d9",
    strokeWidth: 6.50391,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.656 119.398L211.227 10.8274",
    stroke: "#7f56d9",
    strokeWidth: 6.50391,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.763 3.70089L172.966 25.4968C172.03 26.4333 171.541 27.7276 171.624 29.0496L172.886 49.1602L198.565 23.481L197.386 4.69252C197.303 3.37049 195.699 2.76433 194.763 3.70089Z",
    stroke: "#7f56d9",
    strokeWidth: 6.50391,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.346 27.2897L196.55 49.0856C195.613 50.0222 194.319 50.5113 192.997 50.4285L172.886 49.1663L198.565 23.4871L217.354 24.6665C218.676 24.7493 219.282 26.3532 218.346 27.2897Z",
    stroke: "#7f56d9",
    strokeWidth: 6.50391,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4673_12762"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 222,
    height: 222,
    fill: "white",
    transform: "translate(0.0507812)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoals);
export default __webpack_public_path__ + "static/media/goals.8e1241770f820c8bfea1847bc479015d.svg";
export { ForwardRef as ReactComponent };